import TimePicker from "./vue/timePicker/TimePicker";

// defining this here so the DatePicker import gets used
customElements.define("sky-timepicker", TimePicker);

export function closeModal(element: JQuery<HTMLElement>)
{
    const control = element.closest("sky-timepicker");
    if (control.length > 0 && (control[0] as any).closeModal)
    {
        (control[0] as any).closeModal()
    }
}